module.exports = __webpack_public_path__ + "static/media/cleaning_map.0c11f425.svg";